import { Box } from '@rebass/grid';
import styled from '../Styles/styled-components';

export const LeftContainer = styled(Box)`
  float: left;
  width: 50%;
`;

export default LeftContainer;
